module.exports = __webpack_public_path__ + "img/05.b8459340.png";